import { useRive, useStateMachineInput } from '@rive-app/react-canvas';
import { Input } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type ChangeEvent, memo, useCallback, useContext, useEffect, useState } from 'react';
import { NestleFormWrapperContext } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.context';
import { animations, backgroundImagesMobile } from 'reactApp/sections/Nestle/PetsCard/Nickname/Nickname.data';

import commonStyles from '../PetsCard.css';
import styles from './Nickname.css';

const RIVE_STATE_MACHINE_NAME = 'State Machine 1';
const RIVE_TRIGGER_NAME = 'Trigger 1';

export const Nickname = memo(() => {
    const [animationSrc, setAnimationSrc] = useState<string>('');
    const { formData, formErrors, setFormData, setFormErrors } = useContext(NestleFormWrapperContext);
    const { cardColor } = formData;

    const backgroundImageMobile = backgroundImagesMobile[cardColor];

    const { rive, RiveComponent } = useRive({
        src: animationSrc,
        stateMachines: RIVE_STATE_MACHINE_NAME,
        autoplay: true,
    });

    const triggerAnimation = useStateMachineInput(rive, RIVE_STATE_MACHINE_NAME, RIVE_TRIGGER_NAME);

    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            setFormData((prev) => ({ ...prev, nickname: event.target.value }));
            triggerAnimation?.fire();
            if (formErrors.nickname) {
                setFormErrors((prev) => ({ ...prev, nickname: false }));
            }
        },
        [setFormData, triggerAnimation, formErrors.nickname, setFormErrors]
    );

    useEffect(() => {
        setAnimationSrc(animations[cardColor]);
    }, [cardColor, setAnimationSrc]);

    return (
        <div className={classNames(commonStyles.field, commonStyles.nickname)}>
            <span className={commonStyles.label}>это</span>
            <Input
                type="text"
                placeholder="введите кличку"
                className={classNames(commonStyles.input, {
                    [commonStyles.inputError]: formErrors.nickname,
                })}
                onChange={handleChange}
            />
            <div
                className={classNames(styles.animation, {
                    [styles[`animation_${cardColor}`]]: cardColor,
                })}
            >
                <img src={backgroundImageMobile} alt="nickname-background" className={styles.imageMobile} />
                <div className={styles.animationMobile}>
                    <RiveComponent key={animationSrc} />
                </div>
            </div>
        </div>
    );
});

Nickname.displayName = 'Nickname';
